<template>
  <div class="yjbk-bkgl">
    <div class="u-p5-x-3">
       <template>
         <h4 style="color: aliceblue;margin-top: -30px">
           布控管理
         </h4>
       </template>
      <car-form
        @submit="submit"
        :showformitem="[
          'plateNo',
          'plateClass',
          'timeType',
          'dispositionStatus',
          'title',
          'dispositionType'
        ]"
        :defaultFormValue="timeType"
      >
      <template>
         <el-button type="success" size="small" @click="add">添加</el-button>
      </template>
      </car-form>
    </div>
    <div class="u-h-100">
      <hy-data-table
        v-model="loading"
        height="94%"
        ref="dataTable"
        @find-page="findPage"
        @detail-handle="detailHandle"
        @del="del"
        is-all-handle
        :data="dataTable.list"
        :columns="dataTable.columns"
        :extend-buttons="dataTable.buttons"
        :show-batch-delete="false"
        :show-operation="true"
        size="medium"
        :paging="dataTable.paging"
        :extend-but-widht="130"
      ></hy-data-table>
    </div>
  </div>
</template>

<script>
import carForm from '@/components/form/carForm.vue';
import hyDataTable from '@/components/HyDataTable.vue';
import { mapState } from 'vuex';

export default {
  components: {
    carForm,
    hyDataTable
  },
  data() {
    const timeType = {
      beginTime: this.$myPlug.timeFormat(
        new Date().getTime() - 60000 * 60 * 24 * 7,
        'yyyy-mm-dd hh:MM:ss'
      ),
      endTime: this.$myPlug.timeFormat(
        new Date().getTime(),
        'yyyy-mm-dd hh:MM:ss'
      )
    };
    return {
      saveAddTemplate: {},

      apiUrl: {
        delApi: 'DELETE_hyDispositionDelete',
        addApi: 'POST_hyDispositionAdd',
        detailApi: 'GET_hyDispositionFind',
        updateApi: 'PUT_hyDispositionUpdate',
        indexApi: 'POST_hyDispositionList'
      },
      sortName: [
        '布控标题',
        '布控编号',
        '布控理由',
        '布控类型',
        '布控车牌号',
        '车牌种类',
        '车牌颜色',
        '车型类别',
        '接收布控手机号',
        '布控时间(开始)',
        '布控时间(结束)',
        '每天生效时间',
        '每天失效时间',
        '布控编号',
        '布控者',
        '布控状态',
        '创建时间',
        '修改时间',
        '备注'
      ],
      timeType: {
        0: [timeType.beginTime, timeType.endTime]
      },
      form: {
        ...timeType
      },
      loading: false, // 是否加载的标识
      pageRow: 10,
      pageIndex: 1,
      dataTable: {
        list: {
          // "status": "S",
          // "msg": "查询成功",
          // "count": 1,
          // "pageIndex": 1,
          // "pageRow": 10,
          // "data": [
          //     {
          //         "num": "123456",
          //         "carNum": "粤S12345",
          //         "time": "2022-02-23 18:28:36",
          //         "vehicleType": "小型蓝牌",
          //         "color": "蓝",
          //         // "picPath": "http://10.0.6.170:8089/{6E015000-A034-45E9-A476-C90751C29585}.jpg",
          //         "pinType": "奥迪A7",
          //         "typeB": "小型客车",
          //         "device": "治安卡口",
          //         "street": "东莞市XX街道XX大道"
          //     }
          // ]
        },
        columns: [
          { prop: 'plateNo', label: '车牌号码', minWidth: 130 },
          { prop: 'plateClass', label: '车牌种类', minWidth: 100 },
          { prop: 'title', label: '布控标题', minWidth: 90 },
          { prop: 'createTime', label: '创建时间', minWidth: 120 },
          { prop: 'beginTimeFormat', label: '布控时间(开始)', minWidth: 110 },
          { prop: 'endTimeFormat', label: '布控时间(结束)', minWidth: 110 },
          { prop: 'deviceListName', label: '布控者', minWidth: 100 },
          { prop: 'dispositionType', label: '布控类型', minWidth: 120 },
          { prop: 'dispositionStatus', label: '布控状态', minWidth: 80 },
          { prop: 'receiveMobile', label: '接收布控手机号', minWidth: 120 }
        ],
        buttons: [
          {
            label: '详情',
            click: 'detail-handle',
            perms: 100103,
            // icon: 'fa fa-picture-o',
            type: 'primary'
          },
          {
            label: '删除',
            click: 'del',
            perms: 100102,
            // icon: 'fa fa-picture-o',
            type: 'error'
          }
        ],
        paging: {
          pageIndex: 1 // 表格分页信息
        }
      }
    };
  },
  computed: {
    ...mapState({
      boxDetailRerefsh: (state) => state.detail.boxDetailRerefsh
    })
  },
  methods: {
    submit(form) {
      this.form = form;
      switch (this.form.timeType) {
        case '0':
          if (!this.form.hasOwnProperty('0') || this.form['0'] == null) {
            this.$message.error('创建时间不能为空');
            return;
          }
          this.form.beginTime = this.form['0'][0];
          this.form.endTime = this.form['0'][1];
          break;
        case '1':
          if (!this.form.hasOwnProperty('1') || this.form['1'] == null) {
            this.$message.error('开始时间不能为空');
            return;
          }
          this.form.beginTime = this.form['1'][0];
          this.form.endTime = this.form['1'][1];
          break;
        case '2':
          if (!this.form.hasOwnProperty('2') || this.form['2'] == null) {
            this.$message.error('结束时间不能为空');
            return;
          }
          this.form.beginTime = this.form['2'][0];
          this.form.endTime = this.form['2'][1];
          break;
      }
      console.log(666666, this.form);
      // this.form = {
      //   checkStatus: form.checkStatus,
      //   coEin: form.coEin,
      //   coName: form.coName
      // };
      this.pageIndex = 1;
      this.getData();
    },
    findPage(res1) {
      this.pageIndex = res1.pageRequest.pageIndex;
      this.getData();
    },
    add() {
      const data = this.saveAddTemplate;

      this.$store.commit('boxDetail', {
        data: data,
        title: '新增',
        api: this.apiUrl.addApi,
        sort: this.sortName
      });
    },
    detailHandle(res) {
      const id = res.row.id || res.row.dispositionID;
      this.$http[this.apiUrl.detailApi]({ paramsID: id }).then((response) => {
        if (response.data)
          response.data.beginTime = response.data.beginTimeFormat;
        response.data.endTime = response.data.endTimeFormat;
        this.$store.commit('boxDetail', {
          data: response.data,
          title: '详情',
          api: this.apiUrl.updateApi,
          sort: this.sortName
        });
      });
    },
    del(res) {
      this.$http[this.apiUrl.delApi]({ paramsID: res.row.dispositionID }).then(
        (response) => {
          if ((response.code = '00000')) {
            this.$message.success('删除成功');
            if (this.dataTable.list.data.length === 1)
              this.pageIndex = this.pageIndex - 1;
            this.getData();
          } else {
            this.$message.error('删除失败:' + response.msg);
          }
        }
      );
    },
    getData() {
      this.form.pageIndex = this.pageIndex;
      this.form.pageRow = this.pageRow;
      let arr = [];
      this.$http[this.apiUrl.indexApi](this.form)
        .then((response) => {
          if (response.data && response.data.length > 0) {
            for (var i = 0; i < response.data.length; i++) {
              const result = this.$myPlug.sortName2cn(response.data[i]);
              arr.push(result);
            }
          }
          this.dataTable.list = {
            pageRow: this.pageRow,
            count: response.total,
            pageIndex: 1,
            data: []
          };
          this.$set(this.dataTable.list, 'data', arr);
          this.saveAddTemplate = JSON.parse(
            JSON.stringify(this.dataTable.list.data[0])
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  created() {
    this.getData();
  },
  watch: {
    boxDetailRerefsh(nval) {
      if (nval) this.getData();
    }
  }
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/views/yjbk/bkgl.vue